export default theme => ({
  yektanet: {
    margin: '0 !important',
  },
  widgetWrapper: {
    textAlign: 'center',
  },
  widgetContainer: {
    display: 'inline-block'
  }
});